export enum ConversationContactStatusEnum {
  Valid = 'valid',
  Invalid = 'invalid',
}
